import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Gabung kelas dengan penyelesaian konflik.
 *
 * clsx mengendalikan kelas bersyarat; twMerge membuang konflik Tailwind supaya
 * kelas yang dihantar pemanggil menang terhadap kelas lalai komponen. Tanpa
 * twMerge, menghantar className="px-8" kepada komponen yang sudah mempunyai
 * "px-4" menghasilkan kedua-duanya, dan yang menang bergantung pada susunan
 * dalam fail CSS — bukan pada niat pemanggil.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
